import { ProductCard, Product } from '@components/ProductCard';
import SlickSlider from '@ui/SlickSlider';
import { SliderArrowProps, SliderArrow } from '@ui/SliderArrow';

import s from './ProductsCarousel.sss';

// constants
const MAX_PRODUCTS_COUNT_INLINE = 4;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowLeft: React.FC<SliderArrowProps> = ({ className, ...props }) => (
  <SliderArrow {...props} direction="left" />
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowRight: React.FC<SliderArrowProps> = ({ className, ...props }) => (
  <SliderArrow {...props} />
);

interface Props {
  products: Product[],
}

export const ProductsCarousel: React.FC<Props> = ({
  products,
}) => {
  const isSlider = products.length > MAX_PRODUCTS_COUNT_INLINE;

  const productsList = products.map(
    (product) => (
      <ProductCard
        key={product.id}
        className={s.product}
        {...product}
      />
    ),
  );

  if (isSlider) {
    return (
      <div>
        <SlickSlider
          speed={400}
          prevArrow={<ArrowLeft />}
          nextArrow={<ArrowRight />}
          slidesToShow={1}
          infinite={true}
          variableWidth={true}
          swipeToSlide={true}
          waitForAnimate={false}
        >
          {productsList}
        </SlickSlider>
      </div>
    );
  }

  return (
    <div className={s.list}>
      {productsList}
    </div>
  );
};
